import { useDebounce } from "@uidotdev/usehooks";
import { useSearchParams } from "react-router-dom";

import Pagination from "../components/Pagination";
import { PatientSearchTable } from "../components/patientSearch";
import { PatientSearchFilters } from "../components/patientSearch/PatientSearchFilters";
import { PATIENT_FILTER_PARAMS } from "../constants";
import { useGetPatients } from "../hooks";
import { defaultPatientSearchParams } from "../utils";

export const PatientSearch = () => {
  const [params] = useSearchParams({
    ...defaultPatientSearchParams,
    [PATIENT_FILTER_PARAMS.isSearch]: "true",
  });

  const debouncedParams = useDebounce(params, 600);
  const {
    data: patients,
    isLoading,
    isFetching,
  } = useGetPatients(debouncedParams);
  const { data: patientsData } = { ...patients };
  const hasPatients = !!patientsData?.length;

  return (
    <div className="flex h-full w-full flex-col gap-4 px-6 py-8 text-sm md:px-14">
      <PatientSearchFilters
        totalPatients={patients?.total_items}
        isLoading={isLoading}
        hasNoPatients={!hasPatients}
        filteredPatientsCount={patients?.filtered_count}
      />
      <PatientSearchTable
        patients={patientsData ?? []}
        isLoading={isLoading}
        isFetching={isFetching}
      />
      {patients && patients.total_pages > 1 && (
        <div className="flex w-full justify-end">
          <Pagination
            totalItems={patients.filtered_count}
            currentPage={patients.page}
            totalPages={patients.total_pages}
          />
        </div>
      )}
    </div>
  );
};
